import React, { useEffect, useState, VFC } from 'react';

import { AxiosInstance } from 'axios';
import { noop } from 'lodash';
import { Spinner } from 'mintel-react-ui';

import { CustomAccessType, CustomPanelType } from '/types';
import { Trans } from '/utils/translations';

import AccessList from './AccessList';
import styles from './AccessPanel.scss';
import useFetchCustomAccess from './useFetchCustomAccess';

type AccessPanelProps = {
  cwaAxios: AxiosInstance;
  articleAccessUrl: string;
  trackAccessPanel: () => void;
};

const AccessPanelComponent: VFC<AccessPanelProps> = ({
  cwaAxios,
  articleAccessUrl,
  trackAccessPanel,
}) => {
  const [access, setAccess] = useState([] as CustomAccessType[]);
  useFetchCustomAccess(cwaAxios, articleAccessUrl, setAccess);
  useEffect(() => {
    trackAccessPanel();
    // We really only want this to run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      {!!access.length && <div className={styles['scroll-gradient']} />}
      <div className={styles.lists}>
        {!!access.length ? (
          access.map(({ key, title, accessItems }: CustomAccessType) => (
            <AccessList key={key} title={title} accessItems={accessItems} />
          ))
        ) : (
          <div className={styles.spinner}>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const AccessPanel = (
  cwaAxios: AxiosInstance,
  articleAccessUrl: string,
  trackAccessPanel: () => void,
): CustomPanelType => ({
  children: (
    <AccessPanelComponent
      cwaAxios={cwaAxios}
      articleAccessUrl={articleAccessUrl}
      trackAccessPanel={trackAccessPanel}
    />
  ),
  closeSidebar: noop,
  color: 'tertiary',
  iconName: 'key',
  title: <Trans>Access</Trans>,
  subtitle: (
    <Trans>
      This content piece can be accessed by the organisations, groups and
      individuals listed below. The Project Owner can change the client access
      settings through the CMS.
    </Trans>
  ),
  width: 800,
  id: 'access-panel',
});

export default AccessPanel;
